<template>
    <el-dialog
        :title="config.dialogTitle"
        :width="config.width"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'evidenceUploadDialog'"
    >
        <div class="topTip" v-if="config.operateType !== 'view'">
            <div class="el-icon-info"></div>
            <p>
                图片类型提示：需上传由客户签“已上楼”回单照片或机器放置在客户指定位置的照片或上楼中的照片，需带水印地址和时间或者客户微信答复”已上楼“的微信截图
            </p>
        </div>
        <div class="uploadWrapper" v-loading="loading">
            <!-- 已上传过图 -->
            <template v-if="attachmentList.length > 0">
                <div class="uploadInfo">
                    <div v-show="currentData.updateUserName">
                        <span style="margin-right: 5px">{{
                            currentData.updateUserName
                        }}</span>
                        在<span style="margin: 0 10px">{{
                            currentData.updateTime
                        }}</span
                        >上传
                    </div>
                </div>
                <div style="height: 200px">
                    <ul id="viewers" style="display: none">
                        <li v-for="(imgUrl, index) in pathList" :key="index">
                            <img :src="imgUrl" />
                        </li>
                    </ul>
                </div>
                <div class="currentImgIndex">
                    {{ carouselIndex + 1 + ' / ' + attachmentList.length }}
                </div>
            </template>
            <!-- 未上传图片 -->
            <template v-else>
                <div class="notUpload" v-loading="uploadLoading">
                    <performance-common-upload
                        ref="performanceCommonUpload"
                        :type="'icon'"
                        :icon="'el-icon-plus notImg'"
                        :showFileList="true"
                        :accept="'.jpg,.jpeg,.png'"
                        :multiple="true"
                        @beforeUpload="beforeUpload"
                        @callback="uploadResponse"
                    ></performance-common-upload>
                </div>
            </template>
            <!-- 备注 -->
            <div class="evidence-remark">
                <el-input
                    v-model.trim="evidenceRemark"
                    placeholder="请输入备注"
                    :disabled="config.operateType === 'view'"
                />
            </div>
        </div>
        <template #footer>
            <div>
                <el-button @click="beforeClose">取消</el-button>
                <el-button
                    v-if="config.operateType !== 'view'"
                    type="primary"
                    :loading="submitLoading"
                    @click="handleSubmit"
                    >确定</el-button
                >
            </div>
        </template>
    </el-dialog>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import PerformanceCommonUpload from './PerformanceCommonUpload.vue';
import { receiptCvteUpload } from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { handleGetAttachmentDetail } from '../util.js';
export default {
    name: 'evidenceUploadDialog',
    components: { PerformanceCommonUpload },
    props: {
        config: {
            type: Object,
            default () { return {}; }
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false, // 附件加载动画
            uploadLoading: false, // 上传加载动画
            submitLoading: false, // 确定按钮动画
            carouselIndex: 0, // 当前展示的图片索引
            currentData: {}, // 当前展示的图片数据
            viewer: {}, // viewer插件实例对象
            evidenceRemark: '', // 备注
            attachmentList: [], // 附件信息列表
            pathList: [], // 图片列表
            uploadData: [] // oss回调的附件列表
        };
    },
    methods: {
        // 获取附件列表
        getAttachmentList () {
            this.loading = true;
            handleGetAttachmentDetail(this.rowData.id, 'RECEIPT_CVTE_CONFIRM').then(res => {
                this.attachmentList = res;
                if (this.attachmentList.length > 0) {
                    this.evidenceRemark = this.attachmentList[0].attachmentRemark;
                    this.refreshAttachment();
                }
            }).finally(() => { this.loading = false; });
        },

        // 初始化viewer组件
        initViewer () {
            if (this.attachmentList.length > 0) {
                this.viewer = new Viewer(document.getElementById('viewers'), {
                    title: false,
                    inline: true,
                    navbar: false,
                    backdrop: true, // 隐藏透明背景色
                    zoomOnWheel: false, // 禁止滚动滑动缩放
                    viewed: data => { // 图片加载完成时回调
                        this.updateInfo(data.detail.index);
                    }
                });
            }
        },

        /**
         * @description 切换图片时，更新图片上传信息
         * @param {Number} index 当前显示图片索引
         */
        updateInfo (index) {
            this.carouselIndex = index;
            this.currentData = this.attachmentList[index];
        },

        // 刷新附件列表
        refreshAttachment () {
            this.viewer.element && this.viewer.destroy(); // 删除viewer上一次的实例
            this.pathList = this.attachmentList.map(v => v.path);
            this.$nextTick(() => {
                this.initViewer();
            });
        },

        // 上传之前回调
        beforeUpload () {
            this.uploadLoading = true;
        },

        // 上传成功回调
        uploadResponse (uploadData) {
            this.uploadLoading = false;
            this.uploadData = uploadData;
        },

        /**
         * @description 处理提交参数
         * @param {Array} uploadData 上传回调参数列表
         */
        dealWithSubmitParams () {
            return {
                fileData: this.uploadData.map(v => ({
                    fileName: v.fileName,
                    fileSize: v.fileSize,
                    fileUrls: v.fileUrl,
                    remark: this.evidenceRemark
                })), // 多选上传文件列表
                receiptSource: this.rowData.receiptSource, // 上传方式
                taskNo: this.rowData.taskNo // 运输单号
            };
        },

        // 确定
        handleSubmit () {
            if (this.uploadData.length === 0) {
                return this.$message.warning('请先上传附件再点确定！');
            }
            this.submitLoading = true;
            const params = this.dealWithSubmitParams();
            receiptCvteUpload(params).then(res => {
                if (res && +res.code === 0) {
                    if (Array.isArray(res.data) && res.data.length > 0) {
                        return this.$message.warning(res.data[0].message);
                    }
                    this.$message.success('上传成功');
                    this.$emit('upload-success', 'leftUploadRightContentVisible');
                }
            }).finally(() => { this.submitLoading = false; });
        },

        // 关闭之前回调
        beforeClose () {
            this.$emit('update:visible', false);
        }
    },
    mounted () {
        if (this.config.operateType !== 'edit') {
            this.getAttachmentList();
        }
    }
};
</script>
<style lang="less">
@import url('./less/evidenceUploadDialog.less');
</style>
